define("discourse/plugins/discourse-layouts/discourse/components/admin-widget-item", ["exports", "../models/layout-widget", "../lib/layouts", "discourse-common/utils/decorators", "@ember/object/computed", "@ember/object", "@ember/component", "I18n"], function (_exports, _layoutWidget, _layouts, _decorators, _computed, _object, _component, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _obj;

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function buildSelectKit(items) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return items.map(function (item) {
      var name = item;
      var id = item;

      if (['position', 'order'].indexOf(type) > -1 && isNaN(item)) {
        name = _I18n.default.t("admin.layouts.widgets.".concat(type, ".").concat(item));
      }

      if (type === 'filter') {
        name = _I18n.default.t("filters.".concat(item, ".title"));
      }

      if (type === 'context') {
        name = (0, _layouts.normalizeContext)(item, {
          name: true
        });
      }

      if (['group', 'category'].indexOf(type) > -1) {
        if (item === 0) {
          name = _I18n.default.t('categories.all');
        } else {
          name = item.name;
          id = item.id;
        }
      }

      return {
        id: id,
        name: name
      };
    });
  }

  function generateDisplayName(name) {
    return name.replace("layouts-", "").replace(/[_\-]+/g, ' ').replace(/(^\w|\b\w)/g, function (m) {
      return m.toUpperCase();
    });
  }

  var _default = _component.default.extend((_dec = (0, _decorators.default)('widgets.length'), _dec2 = (0, _decorators.default)('site.groups'), _dec3 = (0, _decorators.default)('site.categories'), _dec4 = (0, _decorators.default)('widget.name'), (_obj = {
    classNames: 'admin-layouts-widget',
    saveDisabled: (0, _computed.not)('dirty'),
    dirty: false,
    positionList: (0, _object.computed)(function () {
      return buildSelectKit(['left', 'right'], 'position');
    }),
    orderList: function orderList(widgetCount) {
      var items = ['start', 'end'];

      if (widgetCount > 0) {
        for (var i = 1; i <= widgetCount; i++) {
          items.push(i.toString());
        }
      }

      return buildSelectKit(items, 'order');
    },
    contextList: (0, _object.computed)(function () {
      return buildSelectKit((0, _layouts.listNormalisedContexts)(), 'context');
    }),
    filterList: (0, _object.computed)(function () {
      return buildSelectKit([].concat(_toConsumableArray(this.site.filters), ['top', 'categories']), 'filter');
    }),
    groupList: function groupList(siteGroups) {
      var list = buildSelectKit(siteGroups.filter(function (group) {
        return group.name !== 'everyone';
      }), 'group');
      return list;
    },
    categoryList: function categoryList(siteCategories) {
      return buildSelectKit([0].concat(_toConsumableArray(siteCategories)), 'category');
    },
    didInsertElement: function didInsertElement() {
      this._super.apply(this, arguments);

      if (!this.widget.isNew) {
        this.set('existingWidget', JSON.parse(JSON.stringify(this.widget)));
      }
    },
    update: function update(type, value) {
      this.set("widget.".concat(type), value);
      var widget = this.widget;

      if (widget.isNew) {
        this.set('dirty', !!widget.name);
      } else {
        this.set('dirty', value !== this.existingWidget[type]);
      }
    },
    widgetDisplayName: function widgetDisplayName(name) {
      return generateDisplayName(name);
    },
    widgetList: function widgetList() {
      return (0, _layouts.listLayoutsWidgets)().map(function (name) {
        return {
          id: name,
          name: generateDisplayName(name)
        };
      });
    },
    actions: {
      updateOrder: function updateOrder(order) {
        this.update('order', order);
      },
      updatePosition: function updatePosition(position) {
        this.update('position', position);
      },
      updateGroups: function updateGroups(groups) {
        this.update('groups', groups);
      },
      updateEnabled: function updateEnabled(enabled) {
        this.update('enabled', enabled);
      },
      updateCategoryIds: function updateCategoryIds(categoryIds) {
        this.update('category_ids', categoryIds);
      },
      updateExcludedCategoryIds: function updateExcludedCategoryIds(categoryIds) {
        this.update('excluded_category_ids', categoryIds);
      },
      updateFilters: function updateFilters(filters) {
        this.update('filters', filters);
      },
      updateContexts: function updateContexts(contexts) {
        this.update('contexts', contexts);
      },
      updateNewWidgetName: function updateNewWidgetName(widget) {
        this.set("widget.name", widget);
      },
      save: function save() {
        var _this = this;

        if (!this.dirty) return false;
        var widget = this.widget;

        if (widget.isNew && !widget.name) {
          return false;
        }

        this.set('saving', true);

        _layoutWidget.default.save(widget).then(function (result) {
          if (result.widget) {
            _this.setProperties({
              widget: result.widget,
              existingWidget: JSON.parse(JSON.stringify(result.widget))
            });
          } else if (_this.existingWidget) {
            _this.set('widget', _this.existingWidget);
          }

          _this.set('dirty', false);
        }).finally(function () {
          return _this.set('saving', false);
        });
      },
      remove: function remove() {
        var _this2 = this;

        var widget = this.widget;
        if (!widget) return false;
        this.set('saving', true);

        _layoutWidget.default.remove(widget).then(function (result) {
          if (result.success) {
            _this2.removeWidget(widget);
          } else {
            _this2.set('saving', false);
          }

          ;
        });
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "orderList", [_dec], Object.getOwnPropertyDescriptor(_obj, "orderList"), _obj), _applyDecoratedDescriptor(_obj, "groupList", [_dec2], Object.getOwnPropertyDescriptor(_obj, "groupList"), _obj), _applyDecoratedDescriptor(_obj, "categoryList", [_dec3], Object.getOwnPropertyDescriptor(_obj, "categoryList"), _obj), _applyDecoratedDescriptor(_obj, "widgetDisplayName", [_dec4], Object.getOwnPropertyDescriptor(_obj, "widgetDisplayName"), _obj), _applyDecoratedDescriptor(_obj, "widgetList", [_decorators.default], Object.getOwnPropertyDescriptor(_obj, "widgetList"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-layouts/discourse/components/sidebar-container", ["exports", "discourse/components/mount-widget", "discourse-common/utils/decorators", "@ember/object/computed", "discourse-common/lib/get-owner", "@ember/runloop", "../lib/layouts", "@ember/service"], function (_exports, _mountWidget, _decorators, _computed, _getOwner, _runloop, _layouts, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _mountWidget.default.extend((_dec = (0, _decorators.on)('init'), _dec2 = (0, _decorators.default)('context'), _dec3 = (0, _decorators.observes)('path', 'mobileView', 'tabletView'), (_obj = {
    classNameBindings: [':layouts-sidebar-container', 'editing'],
    widget: 'sidebar',
    router: (0, _service.inject)(),
    path: (0, _computed.alias)("router._router.currentPath"),
    setupRerenderTrigger: function setupRerenderTrigger() {
      var _this = this;

      var side = this.get('side');
      this.appEvents.on('sidebars:rerender', function () {
        _this.rerenderSidebars();
      });
    },
    controller: function controller(context) {
      return (0, _getOwner.getOwner)(this).lookup("controller:".concat((0, _layouts.getAttrFromContext)(context, 'controller')));
    },
    buildArgs: function buildArgs() {
      var side = this.side;
      var controller = this.controller;
      var context = this.context;
      var path = this.path;
      var tabletView = this.tabletView;
      var mobileView = this.mobileView;
      var sidebarMinimized = this.sidebarMinimized;
      var args = {
        context: context,
        path: path,
        side: side,
        controller: controller,
        mobileView: mobileView,
        tabletView: tabletView,
        sidebarMinimized: sidebarMinimized
      };

      if (context === 'discovery') {
        args.filter = this.filter;
      }

      if (['discovery', 'topic'].indexOf(context) > -1 && path !== "discovery.categories") {
        args.category = this.category;
      }

      if (context === 'topic') {
        args.topic = this.topic;
      }

      var customSidebarProps = this.customSidebarProps;

      if (customSidebarProps) {
        args.customSidebarProps = customSidebarProps;
      }

      return args;
    },
    rerenderSidebars: function rerenderSidebars() {
      var _this2 = this;

      this.queueRerender();
      (0, _runloop.scheduleOnce)('afterRender', function () {
        _this2.appEvents.trigger('sidebars:after-render');
      });
    }
  }, (_applyDecoratedDescriptor(_obj, "setupRerenderTrigger", [_dec], Object.getOwnPropertyDescriptor(_obj, "setupRerenderTrigger"), _obj), _applyDecoratedDescriptor(_obj, "controller", [_dec2], Object.getOwnPropertyDescriptor(_obj, "controller"), _obj), _applyDecoratedDescriptor(_obj, "rerenderSidebars", [_dec3], Object.getOwnPropertyDescriptor(_obj, "rerenderSidebars"), _obj)), _obj)));

  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/discourse/connectors/admin-menu/layouts-nav-button"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"if\",[[24,[\"currentUser\",\"admin\"]]],null,{\"statements\":[[0,\"  \"],[1,[28,\"nav-item\",null,[[\"route\",\"label\"],[\"adminLayouts\",\"admin.layouts.label\"]]],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/connectors/admin-menu/layouts-nav-button"}});
define("discourse/plugins/discourse-layouts/discourse/controllers/admin-layouts-widgets", ["exports", "@ember/object", "@ember/controller"], function (_exports, _object, _controller) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _controller.default.extend({
    actions: {
      addWidget: function addWidget() {
        this.get('widgets').unshiftObject(_object.default.create({
          isNew: true
        }));
      },
      removeWidget: function removeWidget(widget) {
        this.get('widgets').removeObject(widget);
      }
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-layouts/discourse/controllers/review", ["exports", "@ember/controller"], function (_exports, _controller) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _controller.default.extend();

  _exports.default = _default;
});
define("discourse/plugins/discourse-layouts/discourse/initializers/sidebars", ["exports", "discourse-common/utils/decorators", "@ember/object/computed", "@ember/controller", "@ember/service", "../lib/layouts", "discourse/lib/plugin-api"], function (_exports, _decorators, _computed, _controller, _service, _layouts, _pluginApi) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var PLUGIN_ID = 'discourse-layouts';
  var _default = {
    name: 'sidebars',
    initialize: function initialize(container, app) {
      var site = container.lookup('site:main');
      var siteSettings = container.lookup('site-settings:main');
      var router = container.lookup('router:main');
      if (!siteSettings.layouts_enabled || site.mobileView && !siteSettings.layouts_mobile_enabled) return;
      (0, _layouts.setupContexts)(app);
      router.on('routeDidChange', function (transition) {
        if (!transition.from) {
          return;
        }

        var routeInfos = transition.router.currentRouteInfos;
        var routeNames = routeInfos.map(function (ri) {
          return ri.name;
        });
        var changedToContext;
        routeNames.forEach(function (routeName) {
          var routeContext = (0, _layouts.getContextFromAttr)(routeName, 'route');

          if (routeContext) {
            changedToContext = (0, _layouts.normalizeContext)(routeContext);
          }
        });

        if (!changedToContext) {
          var classes = document.body.className.split(" ").filter(function (c) {
            return !c.startsWith("".concat(_layouts.layoutsNamespace, "-"));
          });
          document.body.className = classes.join(" ").trim();
        }
      });
      (0, _pluginApi.withPluginApi)('0.8.32', function (api) {
        var _dec, _obj, _dec2, _obj2;

        api.modifyClass('controller:discovery', (_dec = (0, _decorators.default)('navigationDefault.filterType', 'navigationCategory.filterType', 'currentPath'), (_obj = {
          pluginId: PLUGIN_ID,
          router: (0, _service.inject)(),
          currentPath: (0, _computed.readOnly)("router.currentRouteName"),
          navigationDefault: (0, _controller.inject)("navigation/default"),
          navigationCategory: (0, _controller.inject)("navigation/category"),
          sidebarFilter: function sidebarFilter(defaultFilter, categoryFilter, currentPath) {
            if (!currentPath) return undefined;
            var path = currentPath.toLowerCase();
            if (path.indexOf('categories') > -1) return 'categories';
            if (path.indexOf('category') > -1) return categoryFilter;
            return defaultFilter;
          }
        }, (_applyDecoratedDescriptor(_obj, "sidebarFilter", [_dec], Object.getOwnPropertyDescriptor(_obj, "sidebarFilter"), _obj)), _obj)));
        api.modifyClass('controller:topic', {
          pluginId: PLUGIN_ID,
          category: (0, _computed.alias)('model.category'),
          userHideRightSidebar: false
        });
        api.modifyClass('component:topic-navigation', (_dec2 = (0, _decorators.observes)('controller.hasRightSidebar'), (_obj2 = {
          pluginId: PLUGIN_ID,
          controller: (0, _controller.inject)('topic'),
          sidebarsUpdated: function sidebarsUpdated() {
            this._performCheckSize();
          },
          _performCheckSize: function _performCheckSize() {
            if (!this.element || this.isDestroying || this.isDestroyed) return;
            var hasRightSidebar = this.controller.get('hasRightSidebar');

            if (hasRightSidebar && !this.info.get("topicProgressExpanded")) {
              var info = this.get('info');
              info.setProperties({
                renderTimeline: false,
                renderAdminMenuButton: true
              });
            } else {
              this._super.apply(this, arguments);
            }
          }
        }, (_applyDecoratedDescriptor(_obj2, "sidebarsUpdated", [_dec2], Object.getOwnPropertyDescriptor(_obj2, "sidebarsUpdated"), _obj2)), _obj2)));
      });
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-layouts/discourse/layouts-admin-route-map", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    resource: 'admin',
    map: function map() {
      this.route('adminLayouts', {
        path: '/layouts',
        resetNamespace: true
      }, function () {
        this.route('widgets', {
          path: '/widgets'
        });
      });
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-layouts/discourse/lib/layouts", ["exports", "discourse/widgets/widget", "../mixins/sidebars", "discourse/routes/discourse", "@ember/controller", "discourse/lib/plugin-api", "@ember/string", "I18n"], function (_exports, _widget, _sidebars, _discourse, _controller, _pluginApi, _string, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.addSidebarProps = addSidebarProps;
  _exports.createLayoutsWidget = createLayoutsWidget;
  _exports.lookupLayoutsWidget = lookupLayoutsWidget;
  _exports.listLayoutsWidgets = listLayoutsWidgets;
  _exports.normalizeContext = normalizeContext;
  _exports.setupContexts = setupContexts;
  _exports.getAttrFromContext = getAttrFromContext;
  _exports.getContextFromAttr = getContextFromAttr;
  _exports.listNormalisedContexts = listNormalisedContexts;
  _exports.layoutsNamespace = void 0;

  function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  var layoutsNamespace = "layouts";
  _exports.layoutsNamespace = layoutsNamespace;
  var PLUGIN_ID = 'discourse-layouts';
  var contexts = ['discovery', 'topic', 'user', 'users', 'tags-index', {
    name: 'tag-show',
    template: 'tag-show'
  }, 'groups-index', 'groups-new', 'group', {
    name: 'badges-index',
    route: 'badges-index',
    controller: 'badges/index'
  }, {
    name: 'badges-show',
    route: 'badges-show',
    controller: 'badges/show'
  }, 'review', 'admin', {
    name: 'search',
    route: 'full-page-search',
    controller: 'full-page-search',
    template: 'full-page-search'
  }];

  function addSidebarProps(props) {
    if ($.isEmptyObject(props)) return;
    var container = Discourse.__container__;
    var appEvents = container.lookup("service:app-events");
    contexts.forEach(function (context) {
      var controllerName = contextAttr(context, 'controller');
      var controller = container.lookup("controller:".concat(controllerName));

      if (controller) {
        controller.set('customSidebarProps', Object.assign({}, controller.customSidebarProps, props));
      }
    });
    appEvents.trigger('sidebars:rerender');
  }

  var _layouts_widget_registry = {};
  var namespace = 'layouts';

  function createLayoutsWidget(name, opts) {
    var fullName = "".concat(namespace, "-").concat(name);
    var widget = (0, _widget.createWidget)(fullName, Object.assign({}, {
      tagName: "div.widget-container.".concat(fullName),
      buildKey: function buildKey() {
        return fullName;
      },
      shouldRender: function shouldRender(attrs) {
        return true;
      }
    }, opts));
    _layouts_widget_registry[fullName] = widget;
    return widget;
  }

  function lookupLayoutsWidget(name) {
    return _layouts_widget_registry[name];
  }

  function listLayoutsWidgets() {
    return Object.keys(_layouts_widget_registry);
  }

  function normalizeContext(input) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var map = {
      discovery: ['topics', 'discovery', 'topic list', 'Topics', "Discovery", "Topic List"],
      topic: ["topic", "Topic"],
      user: ["user", 'profile', "User", 'Profile'],
      users: ["users"],
      tag: ["tag", "tags", "Tag", "Tags", "tags-index", "tag-show"],
      group: ["group", "groups-index", "groups-new"],
      badge: ["badge", "badges-index", "badges-show"],
      review: ["review"],
      admin: ["admin"],
      search: ["search"]
    };
    var context = Object.keys(map).find(function (c) {
      return map[c].includes(input);
    });

    if (opts.name) {
      context = _I18n.default.t({
        discovery: 'admin.layouts.widgets.context.discovery',
        topic: 'topic.title',
        user: 'user.profile',
        users: 'user.users',
        tag: 'tagging.tags',
        group: 'groups.title.one',
        badge: 'admin.badges.badge',
        review: 'review.title',
        admin: 'admin_title',
        search: 'search.search_button'
      }[context]);
    }

    return context;
  }

  ;

  function setupContexts(app) {
    contexts.forEach(function (context) {
      setupContext(context, app);
    });
  }

  function contextAttr(context, attr) {
    var result;

    if (_typeof(context) === 'object') {
      if (context[attr]) {
        result = context[attr];
      } else {
        result = context['name'];
      }
    } else {
      result = context;
    }

    if (attr === 'template') {
      result = result.replace(/-/g, '.');
    }

    return result;
  }

  function getAttrFromContext(contextName, attr) {
    var result;
    contexts.some(function (context) {
      if (contextAttr(context, 'name') === contextName) {
        result = contextAttr(context, attr);
        return true;
      }
    });
    return result;
  }

  function isCamelCase(value) {
    return /[a-z]+((\d)|([A-Z0-9][a-z0-9]+))*([A-Z])?/.test(value);
  }

  function getContextFromAttr(value, attr) {
    var result;

    if (attr === 'route') {
      if (isCamelCase(value)) {
        value = (0, _string.dasherize)(value);
      } else if (value.indexOf('.') !== -1) {
        value = value.replace(/\./g, '-');
      }
    }

    contexts.some(function (context) {
      var contextValue = contextAttr(context, attr);

      if (contextValue === value) {
        result = contextValue;
        return true;
      }
    });
    return result;
  }

  function listNormalisedContexts() {
    return contexts.map(function (context) {
      return normalizeContext(contextAttr(context, 'name'));
    });
  }

  function setupContext(context, app) {
    var name = contextAttr(context, 'name');
    var route = contextAttr(context, 'route');
    var controller = contextAttr(context, 'controller');
    var template = contextAttr(context, 'template');
    var model = contextAttr(context, 'model');
    (0, _pluginApi.withPluginApi)('0.8.32', function (api) {
      api.modifyClass("route:".concat(route), {
        pluginId: PLUGIN_ID,
        renderTemplate: function renderTemplate() {
          this.render('sidebar-wrapper');
          this.render(template, {
            into: 'sidebar-wrapper',
            outlet: 'main-content',
            controller: controller,
            model: this.modelFor(model)
          });
        }
      });
      var controllerClass = "controller:".concat(controller);

      var controllerExists = api._resolveClass(controllerClass);

      if (controllerExists) {
        var klass = api._resolveClass(controllerClass, {});

        klass.class.reopen(_sidebars.default);
        api.modifyClass(controllerClass, {
          pluginId: PLUGIN_ID,
          layouts_context: name
        });
      } else {
        console.log('Layouts context is missing a controller: ', name);
      }
    });
  }
});
define("discourse/plugins/discourse-layouts/discourse/mixins/sidebars", ["exports", "@ember/object", "@ember/object/computed", "@ember/object/mixin", "@ember/runloop", "@ember/service", "@ember/template", "discourse-common/lib/icon-library", "discourse-common/utils/decorators", "discourse/lib/url", "../lib/layouts"], function (_exports, _object, _computed, _mixin, _runloop, _service, _template, _iconLibrary, _decorators, _url, _layouts) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _obj;

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function hasWidgets(widgets, widgetsSet) {
    return !widgetsSet || widgets && widgets.length > 0;
  }

  var _default = _mixin.default.create((_dec = (0, _decorators.default)('layouts_context', 'mobileView'), _dec2 = (0, _decorators.default)('layouts_context', 'mobileView'), _dec3 = (0, _decorators.default)('rightSidebarVisible'), _dec4 = (0, _decorators.default)('leftSidebarVisible'), _dec5 = (0, _decorators.on)('init'), _dec6 = (0, _decorators.observes)('leftSidebarEnabled', 'mobileView', 'tabletView', 'leftSidebarMinimized', 'leftSidebarVisible'), _dec7 = (0, _decorators.on)('willDestroy'), _dec8 = (0, _decorators.default)('path', 'loading', 'mobileView', 'tabletView', 'hasRightSidebar', 'hasLeftSidebar', 'showMobileMenu'), _dec9 = (0, _decorators.default)('mobileView', 'tabletView', 'leftSidebarVisible', 'leftSidebarMinimized'), _dec10 = (0, _decorators.default)('mobileView', 'tabletView', 'rightSidebarVisible'), _dec11 = (0, _decorators.default)('path', 'hasLeftSidebar', 'hasRightSidebar'), _dec12 = (0, _decorators.default)('hasLeftSidebar', 'hasRightSidebar'), _dec13 = (0, _decorators.default)('path', 'mobileView', 'leftSidebarVisible', 'leftSidebarMinimized'), _dec14 = (0, _decorators.default)('path', 'mobileView', 'rightSidebarVisible'), _dec15 = (0, _decorators.default)('leftSidebarEnabled', 'rightSidebarEnabled'), (_obj = {
    router: (0, _service.inject)(),
    path: (0, _computed.alias)("router._router.currentPath"),
    mobileView: false,
    tabletView: false,
    showMobileMenu: (0, _computed.and)('mobileView', 'mobileMenuItems.length'),
    showLeftToggle: (0, _computed.and)('showSidebarToggles', 'leftSidebarEnabled'),
    showRightToggle: (0, _computed.and)('showSidebarToggles', 'rightSidebarEnabled'),
    customSidebarProps: {},
    eitherSidebarVisible: (0, _computed.or)('leftSidebarVisible', 'rightSidebarVisible'),
    neitherSidebarVisible: (0, _computed.not)('eitherSidebarVisible'),
    leftSidebarEnabled: (0, _object.computed)('leftWidgets', 'widgetsSet', function () {
      return hasWidgets(this.leftWidgets, this.widgetsSet);
    }),
    rightSidebarEnabled: (0, _object.computed)('rightWidgets', 'leftFull', 'widgetsSet', function () {
      return !this.leftFull && hasWidgets(this.rightWidgets, this.widgetsSet);
    }),
    hasRightSidebar: (0, _computed.and)('rightSidebarEnabled', 'rightSidebarVisible'),
    hasLeftSidebar: (0, _computed.and)('leftSidebarEnabled', 'leftSidebarVisible'),
    widgetsSet: (0, _computed.or)('leftWidgetsSet', 'rightWidgetsSet'),
    leftFull: (0, _computed.equal)('siteSettings.layouts_sidebar_left_position', 'full'),
    canHideRightSidebar: function canHideRightSidebar(context, mobileView) {
      return this.canHide(context, 'right', mobileView);
    },
    canHideLeftSidebar: function canHideLeftSidebar(context, mobileView) {
      return this.canHide(context, 'left', mobileView);
    },
    canHide: function canHide(context, side, mobileView) {
      return !mobileView && this.siteSettings["layouts_sidebar_".concat(side, "_can_hide")].split('|').map(_layouts.normalizeContext).includes((0, _layouts.normalizeContext)(context));
    },
    toggleRightSidebarIcon: function toggleRightSidebarIcon(visible) {
      var settings = this.siteSettings;
      return visible ? settings.layouts_sidebar_hide_icon : settings.layouts_sidebar_show_icon;
    },
    toggleLeftSidebarIcon: function toggleLeftSidebarIcon(visible) {
      var settings = this.siteSettings;
      return visible ? settings.layouts_sidebar_hide_icon : settings.layouts_sidebar_show_icon;
    },
    setupMixin: function setupMixin() {
      var _this = this;

      var settings = this.siteSettings;
      var sidebarPadding = 20;
      var mainLeftOffset = settings.layouts_sidebar_left_width + sidebarPadding;
      var mainRightOffset = settings.layouts_sidebar_right_width + sidebarPadding;
      (0, _runloop.scheduleOnce)('afterRender', function () {
        _this.handleWindowResize();

        $(window).on('resize', function () {
          return (0, _runloop.debounce)(_this, _this.handleWindowResize, 100);
        });
        var root = document.documentElement;
        root.style.setProperty('--mainLeftOffset', "".concat(_this.mainLeftOffset, "px"));
        root.style.setProperty('--mainRightOffset', "".concat(_this.mainRightOffset, "px"));
      });
      this.appEvents.on('sidebar:toggle', this, this.toggleSidebars);
      var leftSidebarVisible = this.sidebarVisibleDefault('left');
      var rightSidebarVisible = this.sidebarVisibleDefault('right');
      var cachedLeftSidebar = localStorage.getItem('layouts-left-sidebar-minimized');
      var leftSidebarMinimized = ['true', 'false'].includes(cachedLeftSidebar) ? cachedLeftSidebar === 'true' : settings.layouts_sidebar_left_default_minimized;
      this.setProperties({
        mainLeftOffset: mainLeftOffset,
        mainRightOffset: mainRightOffset,
        leftSidebarVisible: leftSidebarVisible,
        rightSidebarVisible: rightSidebarVisible,
        leftWidgetsSet: false,
        rightWidgetsSet: false,
        leftSidebarMinimized: leftSidebarMinimized,
        rightSidebarMinimized: false
      });
      this.router.on('routeWillChange', function (transition) {
        // won't run on initial load
        if (transition.from) {
          _this.setProperties({
            leftWidgetsSet: false,
            rightWidgetsSet: false
          });
        }
      });
    },
    toggleBodyClasses: function toggleBodyClasses() {
      var leftSidebarEnabled = this.get('leftSidebarEnabled');
      var leftSidebarVisible = this.get('leftSidebarVisible');
      var mobileView = this.get('mobileView');
      var tabletView = this.get("tabletView");
      var leftFull = this.get('leftFull');
      var leftSidebarMinimized = this.get('leftSidebarMinimized');
      var addClasses = [];
      var removeClasses = [];

      if (!mobileView && leftSidebarEnabled && leftSidebarVisible && leftFull) {
        addClasses.push("".concat(_layouts.layoutsNamespace, "-left-full"));
      } else {
        removeClasses.push("".concat(_layouts.layoutsNamespace, "-left-full"));
      }

      if (!mobileView && leftSidebarMinimized) {
        addClasses.push("".concat(_layouts.layoutsNamespace, "-sidebar-minimized"));
      } else {
        removeClasses.push("".concat(_layouts.layoutsNamespace, "-sidebar-minimized"));
      }

      if (tabletView) {
        addClasses.push("".concat(_layouts.layoutsNamespace, "-tablet"));
      } else {
        removeClasses.push("".concat(_layouts.layoutsNamespace, "-tablet"));
      }

      addClasses = addClasses.filter(function (className) {
        return !removeClasses.includes(className);
      });

      if (addClasses.length) {
        var _document$body$classL;

        (_document$body$classL = document.body.classList).add.apply(_document$body$classL, _toConsumableArray(addClasses));
      }

      if (removeClasses.length) {
        var _document$body$classL2;

        (_document$body$classL2 = document.body.classList).remove.apply(_document$body$classL2, removeClasses);
      }
    },
    teardownMixin: function teardownMixin() {
      $(window).off('resize', (0, _runloop.bind)(this, this.handleWindowResize));
      this.appEvents.off('sidebar:toggle', this, this.toggleSidebars);
    },
    sidebarVisibleDefault: function sidebarVisibleDefault(side) {
      if (this.mobileView) return false;
      return this.siteSettings["layouts_sidebar_".concat(side, "_default_visibility")] == 'show';
    },
    toggleSidebars: function toggleSidebars(opts) {
      var _this2 = this;

      var mobileView = this.mobileView;
      var side = opts.side,
          value = opts.value,
          target = opts.target;
      var type = opts.type || 'visibility';
      if (target === 'mobile' && !mobileView || target === 'desktop' && mobileView) return;
      var sides = side ? [side] : ['left', 'right'];
      sides.forEach(function (side) {
        if (type === 'minimize') {
          localStorage.setItem('layouts-left-sidebar-minimized', value);

          _this2.set("".concat(side, "SidebarMinimized"), value);
        } else {
          var newVal = [true, false].includes(value) ? value : !Boolean(_this2["".concat(side, "SidebarVisible")]);

          if (mobileView) {
            var $sidebar = $(".sidebar.".concat(side));
            var $sidebarCloak = $(".sidebar-cloak");

            if (newVal) {
              $sidebar.addClass('open');
              $sidebarCloak.css("opacity", 0.5);
              $sidebarCloak.show();
            } else {
              $sidebar.removeClass('open');
              $sidebarCloak.css("opacity", 0);
              $sidebarCloak.hide();
            }
          }

          _this2.set("".concat(side, "SidebarVisible"), newVal);
        }
      });
    },
    handleWindowResize: function handleWindowResize() {
      var windowWidth = $(window).width();
      var mobileThreshold = this.siteSettings.layouts_sidebar_mobile_threshold;
      var tabletThreshold = this.siteSettings.layouts_sidebar_tablet_threshold;
      var mobileView = this.get("mobileView");
      var tabletView = this.get("tabletView");

      if (windowWidth < Number(mobileThreshold)) {
        if (!mobileView) {
          this.setProperties({
            mobileView: true,
            tabletView: false,
            leftSidebarVisible: false,
            rightSidebarVisible: false
          });
        }
      } else {
        if (mobileView) {
          this.setProperties({
            mobileView: false,
            leftSidebarVisible: true,
            rightSidebarVisible: true
          });
        }

        if (windowWidth < Number(tabletThreshold)) {
          if (!tabletView) {
            this.setProperties({
              tabletView: true,
              leftSidebarMinimized: true
            });
          }
        } else {
          if (tabletView) {
            this.setProperties({
              tabletView: false,
              leftSidebarMinimized: false
            });
          }
        }
      }
    },
    mainClasses: function mainClasses(path, loading, mobileView, tabletView, hasRight, hasLeft, showMenu) {
      var p = path.split('.');
      var classes = "".concat(p[0], " ").concat(p[1] ? p[1].split(/(?=[A-Z])/)[0] : '');

      if (hasLeft || hasRight) {
        classes += ' has-sidebars';
      } else {
        classes += ' no-sidebars';
      }

      if (hasLeft) classes += ' left-sidebar';
      if (hasRight) classes += ' right-sidebar';

      if (mobileView) {
        classes += ' mobile';

        if (showMenu) {
          classes += ' has-menu';
        }
      }

      if (tabletView) classes += ' tablet';
      if (loading) classes += ' loading';
      return classes;
    },
    leftClasses: function leftClasses(mobileView, tabletView, visible, leftSidebarMinimized) {
      return this.buildSidebarClasses(mobileView, tabletView, visible, 'left', leftSidebarMinimized);
    },
    rightClasses: function rightClasses(mobileView, tabletView, visible) {
      return this.buildSidebarClasses(mobileView, tabletView, visible, 'right', false);
    },
    buildSidebarClasses: function buildSidebarClasses(mobileView, tabletView, visible, side, sidebarMinimized) {
      var classes = '';

      if (mobileView) {
        classes += 'mobile';

        if (visible) {
          classes += ' open';
        }
      } else {
        if (!visible) {
          classes += ' not-visible';
        }

        if (tabletView) {
          classes += ' tablet';
        }
      }

      classes += " ".concat(this.siteSettings["layouts_sidebar_".concat(side, "_position")]);
      return classes;
    },
    mainStyle: function mainStyle(path, hasLeftSidebar, hasRightSidebar) {
      if (this.mobileView) return;
      var mainLeftOffset = this.mainLeftOffset;
      var mainRightOffset = this.mainRightOffset;
      var leftFull = this.leftFull;
      var offset = 0;
      var style = '';

      if (hasLeftSidebar) {
        offset += mainLeftOffset;
      }

      if (hasRightSidebar) {
        offset += mainRightOffset;
      }

      if (hasLeftSidebar && leftFull) {
        offset = 0;
      }

      style += "width: ".concat(offset > 0 ? "calc(100% - ".concat(offset, "px)") : '100%');
      return (0, _template.htmlSafe)(style);
    },
    rootStyle: function rootStyle(hasLeftSidebar, hasRightSidebar) {
      var root = document.documentElement;
      var leftFull = this.leftFull;

      if (hasLeftSidebar && leftFull) {
        root.style.setProperty('overflow-x', 'hidden');
      }
    },
    leftStyle: function leftStyle(path, mobileView, visible, leftSidebarMinimized) {
      var width = this.siteSettings.layouts_sidebar_left_width;
      var string;

      if (mobileView) {
        string = "width: 100vw; transform: translateX(".concat(visible ? '0' : "-100vw", ");");
      } else {
        string = "width: ".concat(visible ? width : 0, "px;");
      }

      if (!mobileView && leftSidebarMinimized) {
        string = 'width: max-content';
      }

      return (0, _template.htmlSafe)(string);
    },
    rightStyle: function rightStyle(path, mobileView, visible) {
      var width = this.siteSettings.layouts_sidebar_right_width;
      var string;

      if (mobileView) {
        string = "width: 100vw; transform: translateX(".concat(visible ? "0" : "100vw", ");");
      } else {
        string = "width: ".concat(visible ? width : 0, "px;");
      }

      return (0, _template.htmlSafe)(string);
    },
    mobileMenuItems: function mobileMenuItems() {
      var _this3 = this;

      var inputs = this.siteSettings.layouts_mobile_menu.split('|');
      return inputs.reduce(function (items, input) {
        var firstSeperator = input.indexOf("~~");
        var lastSeperator = input.lastIndexOf("~~");
        var type = input.substring(0, firstSeperator),
            icon,
            url;
        var isLink = type === 'link';
        var isSidebarToggle = ['left', 'right'].indexOf(type) > -1;

        if (isLink) {
          icon = input.substring(firstSeperator + 2, lastSeperator);
          url = input.substring(lastSeperator + 2, input.length);
        } else if (isSidebarToggle) {
          icon = input.substring(firstSeperator + 2, input.length);
        }

        if (icon) {
          var iconClass, iconHtml, action, actionParam;

          if (isSidebarToggle && _this3["".concat(type, "SidebarEnabled")]) {
            iconClass = "mobile-toggle ".concat(type);
            action = 'toggleSidebar';
            actionParam = type;
          } else if (isLink) {
            iconClass = 'mobile-link';
            action = 'goToLink';
            actionParam = url;
          }

          try {
            var iconUrl = new URL(icon);
            iconHtml = (0, _template.htmlSafe)("<img src=".concat(iconUrl.href, " class=\"image-icon\">"));
          } catch (_) {
            iconHtml = (0, _iconLibrary.iconHTML)(icon).htmlSafe();
          }

          if (iconHtml && iconClass && action && actionParam) {
            items.push({
              icon: iconHtml,
              class: iconClass,
              action: action,
              actionParam: actionParam
            });
          }
        }

        return items;
      }, []);
    },
    actions: {
      toggleSidebar: function toggleSidebar(side) {
        this.appEvents.trigger('sidebar:toggle', {
          side: side
        });
      },
      setWidgets: function setWidgets(side, widgets) {
        this.set("".concat(side, "Widgets"), widgets);
        this.set("".concat(side, "WidgetsSet"), true);
      },
      goToLink: function goToLink(link) {
        _url.default.routeTo(link);
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "canHideRightSidebar", [_dec], Object.getOwnPropertyDescriptor(_obj, "canHideRightSidebar"), _obj), _applyDecoratedDescriptor(_obj, "canHideLeftSidebar", [_dec2], Object.getOwnPropertyDescriptor(_obj, "canHideLeftSidebar"), _obj), _applyDecoratedDescriptor(_obj, "toggleRightSidebarIcon", [_dec3], Object.getOwnPropertyDescriptor(_obj, "toggleRightSidebarIcon"), _obj), _applyDecoratedDescriptor(_obj, "toggleLeftSidebarIcon", [_dec4], Object.getOwnPropertyDescriptor(_obj, "toggleLeftSidebarIcon"), _obj), _applyDecoratedDescriptor(_obj, "setupMixin", [_dec5], Object.getOwnPropertyDescriptor(_obj, "setupMixin"), _obj), _applyDecoratedDescriptor(_obj, "toggleBodyClasses", [_dec6], Object.getOwnPropertyDescriptor(_obj, "toggleBodyClasses"), _obj), _applyDecoratedDescriptor(_obj, "teardownMixin", [_dec7], Object.getOwnPropertyDescriptor(_obj, "teardownMixin"), _obj), _applyDecoratedDescriptor(_obj, "mainClasses", [_dec8], Object.getOwnPropertyDescriptor(_obj, "mainClasses"), _obj), _applyDecoratedDescriptor(_obj, "leftClasses", [_dec9], Object.getOwnPropertyDescriptor(_obj, "leftClasses"), _obj), _applyDecoratedDescriptor(_obj, "rightClasses", [_dec10], Object.getOwnPropertyDescriptor(_obj, "rightClasses"), _obj), _applyDecoratedDescriptor(_obj, "mainStyle", [_dec11], Object.getOwnPropertyDescriptor(_obj, "mainStyle"), _obj), _applyDecoratedDescriptor(_obj, "rootStyle", [_dec12], Object.getOwnPropertyDescriptor(_obj, "rootStyle"), _obj), _applyDecoratedDescriptor(_obj, "leftStyle", [_dec13], Object.getOwnPropertyDescriptor(_obj, "leftStyle"), _obj), _applyDecoratedDescriptor(_obj, "rightStyle", [_dec14], Object.getOwnPropertyDescriptor(_obj, "rightStyle"), _obj), _applyDecoratedDescriptor(_obj, "mobileMenuItems", [_dec15], Object.getOwnPropertyDescriptor(_obj, "mobileMenuItems"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-layouts/discourse/models/layout-widget", ["exports", "discourse/lib/ajax", "discourse/lib/ajax-error", "@ember/object"], function (_exports, _ajax, _ajaxError, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var LayoutWidget = _object.default.extend();

  LayoutWidget.reopenClass({
    list: function list() {
      return (0, _ajax.ajax)("/admin/layouts/widgets", {
        type: 'GET'
      }).catch(_ajaxError.popupAjaxError);
    },
    save: function save(widget) {
      return (0, _ajax.ajax)("/admin/layouts/widgets/".concat(widget.name), {
        type: widget.isNew ? 'POST' : 'PUT',
        data: {
          widget: JSON.parse(JSON.stringify(widget))
        }
      }).catch(_ajaxError.popupAjaxError);
    },
    remove: function remove(widget) {
      return (0, _ajax.ajax)("/admin/layouts/widgets/".concat(widget.name), {
        type: 'DELETE'
      }).catch(_ajaxError.popupAjaxError);
    }
  });
  var _default = LayoutWidget;
  _exports.default = _default;
});
define("discourse/plugins/discourse-layouts/discourse/routes/admin-layouts-widgets", ["exports", "../models/layout-widget", "discourse/routes/discourse", "@ember/object", "@ember/array"], function (_exports, _layoutWidget, _discourse, _object, _array) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _discourse.default.extend({
    model: function model() {
      return _layoutWidget.default.list();
    },
    setupController: function setupController(controller, model) {
      controller.set('widgets', (0, _array.A)(model.map(function (w) {
        return _object.default.create(w);
      })));
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-layouts/discourse/routes/admin-layouts", ["exports", "discourse/routes/discourse"], function (_exports, _discourse) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _discourse.default.extend({
    redirect: function redirect() {
      this.transitionTo('adminLayouts.widgets');
    },
    actions: {
      showSettings: function showSettings() {
        var controller = this.controllerFor('adminSiteSettings');
        this.transitionTo('adminSiteSettingsCategory', 'plugins').then(function () {
          controller.set('filter', 'layouts');
          controller.set('_skipBounce', true);
          controller.filterContentNow('plugins');
        });
      }
    }
  });

  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/admin/layouts-widgets"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[\"widget\"],\"statements\":[[7,\"div\",true],[10,\"class\",\"admin-layouts-widget-title\"],[8],[0,\"  \\n  \"],[1,[28,\"d-button\",null,[[\"action\",\"label\",\"icon\"],[[28,\"action\",[[23,0,[]],\"addWidget\"],null],\"admin.layouts.widgets.add\",\"plus\"]]],false],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"div\",true],[10,\"class\",\"admin-layouts-widget-list\"],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"widgets\"]]],null,{\"statements\":[[4,\"each\",[[24,[\"widgets\"]]],null,{\"statements\":[[0,\"      \"],[1,[28,\"admin-widget-item\",null,[[\"widget\",\"widgets\",\"removeWidget\"],[[23,1,[]],[24,[\"widgets\"]],[28,\"action\",[[23,0,[]],\"removeWidget\"],null]]]],false],[0,\"\\n\"]],\"parameters\":[1]},null]],\"parameters\":[]},{\"statements\":[[4,\"unless\",[[24,[\"loading\"]]],null,{\"statements\":[[0,\"      \"],[7,\"div\",true],[8],[1,[28,\"i18n\",[\"admin.layouts.widgets.none\"],null],false],[9],[0,\"\\n\"]],\"parameters\":[]},null]],\"parameters\":[]}],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/admin/layouts-widgets"}});
Ember.TEMPLATES["javascripts/admin/layouts"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"admin-nav\",null,null,{\"statements\":[[0,\"  \"],[1,[28,\"nav-item\",null,[[\"route\",\"label\"],[\"adminLayouts.widgets\",\"admin.layouts.widgets.nav\"]]],false],[0,\"\\n  \"],[7,\"li\",true],[8],[7,\"a\",false],[12,\"data-auto-route\",\"true\"],[3,\"action\",[[23,0,[]],\"showSettings\"]],[8],[1,[28,\"i18n\",[\"admin.layouts.settings.label\"],null],false],[9],[9],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"\\n\"],[7,\"div\",true],[10,\"class\",\"admin-container\"],[8],[0,\"\\n  \"],[1,[22,\"outlet\"],false],[0,\"\\n\"],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/admin/layouts"}});
Ember.TEMPLATES["javascripts/components/admin-widget-item"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"div\",true],[10,\"class\",\"top\"],[8],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"details\"],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"widget\",\"isNew\"]]],null,{\"statements\":[[0,\"      \"],[1,[28,\"combo-box\",null,[[\"value\",\"content\",\"onChange\",\"options\"],[[24,[\"widget\",\"name\"]],[24,[\"widgetList\"]],[28,\"action\",[[23,0,[]],\"updateNewWidgetName\"],null],[28,\"hash\",null,[[\"none\",\"allowAny\"],[\"admin.layouts.widgets.select_widget\",true]]]]]],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"      \"],[7,\"h3\",true],[8],[1,[22,\"widgetDisplayName\"],false],[9],[0,\"\\n\"]],\"parameters\":[]}],[0,\"    \\n    \"],[7,\"div\",true],[10,\"class\",\"enabled\"],[8],[0,\"\\n      \"],[1,[28,\"input\",null,[[\"type\",\"checked\",\"click\"],[\"checkbox\",[24,[\"widget\",\"enabled\"]],[28,\"action\",[[23,0,[]],\"updateEnabled\"],[[\"value\"],[\"target.checked\"]]]]]],false],[0,\"\\n      \"],[7,\"span\",true],[8],[1,[28,\"i18n\",[\"admin.layouts.widgets.enabled\"],null],false],[9],[0,\"\\n    \"],[9],[0,\"\\n  \"],[9],[0,\"\\n  \\n  \"],[7,\"div\",true],[10,\"class\",\"controls\"],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"saving\"]]],null,{\"statements\":[[0,\"      \"],[1,[28,\"loading-spinner\",null,[[\"size\"],[\"small\"]]],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"      \"],[1,[28,\"d-button\",null,[[\"action\",\"class\",\"label\",\"icon\",\"disabled\"],[[28,\"action\",[[23,0,[]],\"save\"],null],\"btn btn-primary\",\"admin.layouts.widgets.save\",\"save\",[24,[\"saveDisabled\"]]]]],false],[0,\"\\n        \\n      \"],[1,[28,\"d-button\",null,[[\"action\",\"class\",\"label\",\"icon\"],[[28,\"action\",[[23,0,[]],\"remove\"],null],\"btn\",\"admin.layouts.widgets.remove\",\"times\"]]],false],[0,\"\\n\"]],\"parameters\":[]}],[0,\"  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"div\",true],[10,\"class\",\"bottom\"],[8],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"position-attributes\"],[8],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"control-group position\"],[8],[0,\"\\n      \"],[7,\"label\",true],[10,\"class\",\"control-label\"],[8],[0,\"\\n        \"],[1,[28,\"i18n\",[\"admin.layouts.widgets.position.label\"],null],false],[0,\"\\n      \"],[9],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"controls\"],[8],[0,\"\\n        \"],[1,[28,\"combo-box\",null,[[\"content\",\"value\",\"onChange\",\"options\"],[[24,[\"positionList\"]],[24,[\"widget\",\"position\"]],[28,\"action\",[[23,0,[]],\"updatePosition\"],null],[28,\"hash\",null,[[\"none\"],[\"admin.layouts.widgets.select\"]]]]]],false],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n\\n    \"],[7,\"div\",true],[10,\"class\",\"control-group order\"],[8],[0,\"\\n      \"],[7,\"label\",true],[10,\"class\",\"control-label\"],[8],[0,\"\\n        \"],[1,[28,\"i18n\",[\"admin.layouts.widgets.order.label\"],null],false],[0,\"\\n      \"],[9],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"controls\"],[8],[0,\"\\n        \"],[1,[28,\"combo-box\",null,[[\"content\",\"value\",\"onChange\",\"options\"],[[24,[\"orderList\"]],[24,[\"widget\",\"order\"]],[28,\"action\",[[23,0,[]],\"updateOrder\"],null],[28,\"hash\",null,[[\"none\"],[\"admin.layouts.widgets.select\"]]]]]],false],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n  \"],[9],[0,\"\\n  \\n  \"],[7,\"div\",true],[10,\"class\",\"filter-attributes\"],[8],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"control-group contexts\"],[8],[0,\"\\n      \"],[7,\"label\",true],[10,\"class\",\"control-label\"],[8],[0,\"\\n        \"],[1,[28,\"i18n\",[\"admin.layouts.widgets.context.label\"],null],false],[0,\"\\n      \"],[9],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"controls\"],[8],[0,\"\\n        \"],[1,[28,\"multi-select\",null,[[\"content\",\"value\",\"onChange\",\"options\"],[[24,[\"contextList\"]],[24,[\"widget\",\"contexts\"]],[28,\"action\",[[23,0,[]],\"updateContexts\"],null],[28,\"hash\",null,[[\"none\",\"allowAny\"],[\"admin.layouts.widgets.select\",false]]]]]],false],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n\\n    \"],[7,\"div\",true],[10,\"class\",\"control-group filters\"],[8],[0,\"\\n      \"],[7,\"label\",true],[10,\"class\",\"control-label\"],[8],[0,\"\\n        \"],[1,[28,\"i18n\",[\"admin.layouts.widgets.filter.label\"],null],false],[0,\"\\n      \"],[9],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"controls\"],[8],[0,\"\\n        \"],[1,[28,\"multi-select\",null,[[\"content\",\"value\",\"onChange\",\"options\"],[[24,[\"filterList\"]],[24,[\"widget\",\"filters\"]],[28,\"action\",[[23,0,[]],\"updateFilters\"],null],[28,\"hash\",null,[[\"none\",\"allowAny\"],[\"admin.layouts.widgets.select\",false]]]]]],false],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n  \"],[9],[0,\"\\n  \\n  \"],[7,\"div\",true],[10,\"class\",\"taxonomy-attributes\"],[8],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"control-group groups\"],[8],[0,\"\\n      \"],[7,\"label\",true],[10,\"class\",\"control-label\"],[8],[0,\"\\n        \"],[1,[28,\"i18n\",[\"admin.layouts.widgets.group.label\"],null],false],[0,\"\\n      \"],[9],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"controls\"],[8],[0,\"\\n        \"],[1,[28,\"multi-select\",null,[[\"content\",\"value\",\"onChange\",\"options\"],[[24,[\"groupList\"]],[24,[\"widget\",\"groups\"]],[28,\"action\",[[23,0,[]],\"updateGroups\"],null],[28,\"hash\",null,[[\"none\",\"allowAny\"],[\"admin.layouts.widgets.select\",false]]]]]],false],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n\\n    \"],[7,\"div\",true],[10,\"class\",\"control-group categories\"],[8],[0,\"\\n      \"],[7,\"label\",true],[10,\"class\",\"control-label\"],[8],[0,\"\\n        \"],[1,[28,\"i18n\",[\"admin.layouts.widgets.category.label\"],null],false],[0,\"\\n      \"],[9],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"controls\"],[8],[0,\"\\n        \"],[1,[28,\"multi-select\",null,[[\"content\",\"value\",\"onChange\",\"options\"],[[24,[\"categoryList\"]],[24,[\"widget\",\"category_ids\"]],[28,\"action\",[[23,0,[]],\"updateCategoryIds\"],null],[28,\"hash\",null,[[\"none\",\"allowAny\"],[\"admin.layouts.widgets.select\",false]]]]]],false],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n    \\n    \"],[7,\"div\",true],[10,\"class\",\"control-group excluded-categories\"],[8],[0,\"\\n      \"],[7,\"label\",true],[10,\"class\",\"control-label\"],[8],[0,\"\\n        \"],[1,[28,\"i18n\",[\"admin.layouts.widgets.excluded_category.label\"],null],false],[0,\"\\n      \"],[9],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"controls\"],[8],[0,\"\\n        \"],[1,[28,\"multi-select\",null,[[\"content\",\"value\",\"onChange\",\"options\"],[[24,[\"categoryList\"]],[24,[\"widget\",\"excluded_category_ids\"]],[28,\"action\",[[23,0,[]],\"updateExcludedCategoryIds\"],null],[28,\"hash\",null,[[\"none\",\"allowAny\"],[\"admin.layouts.widgets.select\",false]]]]]],false],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/admin-widget-item"}});
Ember.TEMPLATES["javascripts/sidebar-wrapper"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[\"item\"],\"statements\":[[7,\"div\",true],[10,\"class\",\"content-wrapper\"],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"leftSidebarEnabled\"]]],null,{\"statements\":[[0,\"    \"],[7,\"aside\",true],[11,\"class\",[29,[\"sidebar left \",[22,\"leftClasses\"]]]],[11,\"style\",[22,\"leftStyle\"]],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"canHideLeftSidebar\"]]],null,{\"statements\":[[0,\"        \"],[1,[28,\"d-button\",null,[[\"class\",\"action\",\"actionParam\",\"icon\"],[\"toggle-sidebar left\",[28,\"action\",[[23,0,[]],\"toggleSidebar\"],null],\"left\",[24,[\"toggleLeftSidebarIcon\"]]]]],false],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"      \\n      \"],[1,[28,\"sidebar-container\",null,[[\"side\",\"topic\",\"customSidebarProps\",\"tabletView\",\"mobileView\",\"sidebarMinimized\",\"category\",\"filter\",\"context\"],[\"left\",[24,[\"model\"]],[24,[\"customSidebarProps\"]],[24,[\"tabletView\"]],[24,[\"mobileView\"]],[24,[\"leftSidebarMinimized\"]],[24,[\"category\"]],[24,[\"sidebarFilter\"]],[24,[\"layouts_context\"]]]]],false],[0,\"\\n      \\n      \"],[1,[28,\"plugin-outlet\",null,[[\"name\",\"tagName\",\"connectorTagName\",\"args\"],[\"sidebar-left-bottom\",\"span\",\"div\",[28,\"hash\",null,[[\"customSidebarProps\",\"category\",\"tabletView\",\"mobileView\",\"sidebarMinimized\",\"context\",\"path\"],[[24,[\"customSidebarProps\"]],[24,[\"category\"]],[24,[\"tabletView\"]],[24,[\"mobileView\"]],[24,[\"leftSidebarMinimized\"]],[24,[\"layouts_context\"]],[24,[\"path\"]]]]]]]],false],[0,\"\\n    \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"  \\n  \"],[7,\"div\",true],[11,\"class\",[29,[\"main-content \",[22,\"mainClasses\"]]]],[11,\"style\",[22,\"mainStyle\"]],[8],[0,\"\\n    \"],[1,[28,\"plugin-outlet\",null,[[\"name\"],[\"above-layouts-main-content\"]]],false],[0,\"\\n    \"],[1,[28,\"outlet\",[\"main-content\"],null],false],[0,\"\\n  \"],[9],[0,\"\\n  \\n\"],[4,\"if\",[[24,[\"rightSidebarEnabled\"]]],null,{\"statements\":[[0,\"    \"],[7,\"aside\",true],[11,\"class\",[29,[\"sidebar right \",[22,\"rightClasses\"]]]],[11,\"style\",[22,\"rightStyle\"]],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"canHideRightSidebar\"]]],null,{\"statements\":[[0,\"        \"],[1,[28,\"d-button\",null,[[\"class\",\"action\",\"actionParam\",\"icon\"],[\"toggle-sidebar right\",[28,\"action\",[[23,0,[]],\"toggleSidebar\"],null],\"right\",[24,[\"toggleRightSidebarIcon\"]]]]],false],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"      \\n      \"],[1,[28,\"sidebar-container\",null,[[\"side\",\"topic\",\"customSidebarProps\",\"tabletView\",\"mobileView\",\"sidebarMinimized\",\"category\",\"filter\",\"context\"],[\"right\",[24,[\"model\"]],[24,[\"customSidebarProps\"]],[24,[\"tabletView\"]],[24,[\"mobileView\"]],[24,[\"rightSidebarMinimized\"]],[24,[\"category\"]],[24,[\"sidebarFilter\"]],[24,[\"layouts_context\"]]]]],false],[0,\"\\n      \\n      \"],[1,[28,\"plugin-outlet\",null,[[\"name\",\"tagName\",\"connectorTagName\",\"args\"],[\"sidebar-right-bottom\",\"span\",\"div\",[28,\"hash\",null,[[\"customSidebarProps\",\"category\",\"tabletView\",\"mobileView\",\"sidebarMinimized\",\"context\",\"path\"],[[24,[\"customSidebarProps\"]],[24,[\"category\"]],[24,[\"tabletView\"]],[24,[\"mobileView\"]],[24,[\"rightSidebarMinimized\"]],[24,[\"layouts_context\"]],[24,[\"path\"]]]]]]]],false],[0,\"\\n    \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"  \\n\"],[4,\"if\",[[24,[\"showMobileMenu\"]]],null,{\"statements\":[[0,\"    \"],[7,\"div\",true],[10,\"class\",\"layouts-mobile-menu\"],[8],[0,\"\\n\"],[4,\"each\",[[24,[\"mobileMenuItems\"]]],null,{\"statements\":[[4,\"d-button\",null,[[\"class\",\"action\",\"actionParam\"],[[23,1,[\"class\"]],[28,\"action\",[[23,0,[]],[23,1,[\"action\"]]],null],[23,1,[\"actionParam\"]]]],{\"statements\":[[0,\"          \"],[1,[23,1,[\"icon\"]],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"parameters\":[1]},null],[0,\"    \"],[9],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"sidebar-cloak\"],[8],[9],[0,\"\\n\"]],\"parameters\":[]},null],[9]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/sidebar-wrapper"}});
define("discourse/plugins/discourse-layouts/discourse/widgets/login-required", ["exports", "discourse/widgets/widget"], function (_exports, _widget) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _widget.createWidget)('login-required', {
    tagName: 'div.widget-login-required',
    html: function html() {
      return this.attach('button', {
        label: 'log_in',
        className: 'btn-primary btn-small login-button',
        action: 'showLogin',
        icon: 'user'
      });
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-layouts/discourse/widgets/sidebar", ["exports", "discourse/widgets/widget", "../lib/layouts", "@ember/runloop"], function (_exports, _widget, _layouts, _runloop) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.addCustomWidget = void 0;
  var customWidgets = [];

  var addCustomWidget = function addCustomWidget(widget) {
    var added = false; // replace existing widget record if it exists

    customWidgets.forEach(function (w, i) {
      if (w.name === widget.name) {
        added = true;
        customWidgets[i] = widget;
      }
    });

    if (!added) {
      customWidgets.push(widget);
    }
  };

  _exports.addCustomWidget = addCustomWidget;

  var _default = (0, _widget.createWidget)('sidebar', {
    tagName: 'div.sidebar-content',
    html: function html(args) {
      var _this = this;

      var user = this.currentUser;
      var side = args.side,
          context = args.context,
          controller = args.controller,
          path = args.path,
          filter = args.filter,
          category = args.category,
          topic = args.topic,
          customSidebarProps = args.customSidebarProps,
          tabletView = args.tabletView,
          mobileView = args.mobileView,
          sidebarMinimized = args.sidebarMinimized;
      var siteWidgets = this.site.layout_widgets || [];

      if (customWidgets.length) {
        siteWidgets = siteWidgets.concat(customWidgets);
      }

      context = (0, _layouts.normalizeContext)(context);
      var props = {
        topic: topic,
        category: category,
        side: side,
        path: path,
        mobileView: mobileView,
        tabletView: tabletView,
        sidebarMinimized: sidebarMinimized
      };

      if (customSidebarProps) {
        Object.keys(customSidebarProps).forEach(function (p) {
          props[p] = customSidebarProps[p];
        });
      }

      ;
      var widgets = siteWidgets.filter(function (w) {
        if (!_this.widgetExists(w.name) || w.position !== side || w.contexts.indexOf(context) === -1 || !category && w.category_ids.length || category && w.category_ids.length && w.category_ids.map(function (id) {
          return Number(id);
        }).filter(function (id) {
          return Number(category.id) === id || Number(category.parent_category_id) === id;
        }).length === 0 || category && w.excluded_category_ids.length && w.excluded_category_ids.map(function (id) {
          return Number(id);
        }).some(function (id) {
          return Number(category.id) === id || Number(category.parent_category_id) === id;
        }) || context === 'discovery' && w.filters.length && w.filters.indexOf(filter) === -1) {
          return false;
        } else {
          var LayoutsWidgetClass = _this.lookupWidgetClass(w.name);

          return LayoutsWidgetClass && LayoutsWidgetClass.prototype.shouldRender(props);
        }
      }).sort(function (a, b) {
        if (a.order === b.order) return 0;
        if (a.order === 'start') return -1;
        if (a.order === 'end' || b.order === 'start') return 1;
        return Number(a.order) - Number(b.order);
      }).map(function (w) {
        return w.name;
      });
      var contents = [];

      if (widgets.length > 0) {
        widgets.forEach(function (w) {
          contents.push(_this.attach(w, props));
        });
      }

      controller.send('setWidgets', side, widgets);
      return contents;
    },
    clickOutside: function clickOutside() {
      this.appEvents.trigger('sidebar:toggle', {
        side: this.attrs.side,
        value: false,
        target: 'mobile'
      });
    },
    widgetExists: function widgetExists(widgetName) {
      return (0, _layouts.lookupLayoutsWidget)(widgetName) || this.register.lookupFactory("widget:".concat(widgetName));
    }
  });

  _exports.default = _default;
});

